<template>
  <div :class="$setClasses">
    <div v-if="loading"
         :class="$vClass('loader')">
      <loading-icon class="--primary" />
      <div v-if="loadingText"
           :class="$vClass('loader__text')">{{ getTextVersion(loadingText, getTextParams) }}</div>
    </div>
    <div v-else>
      <div v-if="errorMessage">
        <div :class="$vClass('error-message')">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMoveManager, useMoveManagerEmits, useMoveManagerProps } from '@/composables/useMoveManager';
import { useConfigStore, useInstallmentStore } from '@/stores';
import LoadingIcon from '@/utils/components/LoadingIcon.vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const router = useRouter();

const props = defineProps({
  ...useMoveManagerProps,
});

const emit = defineEmits(useMoveManagerEmits);

const loading = ref(true);
const continueCheck = ref(true);

const { getTextVersion, getTextParams } = useMoveManager({ offer: props.offer }, {emit});

const installmentStore = useInstallmentStore();
const { errorMessage } = storeToRefs(installmentStore);
const configStore = useConfigStore();

const loadingText = computed(() => {
  return configStore.comparatorConfig.installment?.loadingText || '';
});

defineOptions({
  name: 'StepInstallment',
  nameClassStyle: 'step-installment',
});

onMounted(async () => {
  try {
    setTimeout(() => {
      continueCheck.value = false;
    }, 1000 * 30);
    await postInstallmentPaymentPrebookCheck();
  } catch (error) {
  }
});

const postInstallmentPaymentPrebookCheck = async () => {
  try {
    const data = await installmentStore.postInstallmentPaymentPrebookCheck(props.offer?.id ?? '');
    if (data.success) {
      configStore.setOffer(data.quote);
      router.push({
        name: 'booking',
        params: {
          id: props.offer?.id,
        },
        hash: '#confirm',
      });
      loading.value = false;
    } else if (!continueCheck.value) {
      installmentStore.errorMessage = t('installment.error.tooManyRequests');
      router.push({
        name: 'booking',
        params: {
          id: props.offer?.id,
        },
        hash: '#payment',
      });
      loading.value = false;
    } else {
      setTimeout(async () => {
        await postInstallmentPaymentPrebookCheck();
      }, 1000 * 3);
    }
  } catch (error) {
    console.error(error);
    loading.value = false;
    router.push({
      name: 'booking',
      params: {
        id: props.offer?.id,
      },
      hash: '#payment',
    });
  }
};
</script>

<style scoped lang="scss">
.step-installment {
  &__error-message {
    color: var(--nxt-color-danger);
    font-size: 16px;
    font-weight: 600;
  }

  &__loader {
    min-height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>